import { useForm, Controller, useFormState } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
//import { FormContainer, TextFieldElement, DatePickerElement, TimePickerElement, SelectElement } from "react-hook-form-mui";
import * as yup from "yup";

import {
    Dialog,
    Box,
    Button,
    IconButton,
    Typography,
    MenuItem,
    Avatar,
    ListItemText,
    TextField,
    Select,
    InputLabel,
    FormControl,
    Divider,
    List,
    ListItem,
    ListItemButton,
    Menu,
    ClickAwayListener,
    Tooltip,
    CircularProgress,
} from '@mui/material';

import {
    Close,
    AccessTime,
    Workspaces,
    People,
    Videocam,
    Notes,
    AttachFile,
    ContentCopy,
} from '@mui/icons-material';

import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useState, useRef } from "react";

import { useSelector } from "react-redux";
import SearchPeopleAutocomplete from "components/SearchPeopleAutocomplete";
import { createOrUpdateEvent, deleteEvent, removeConferenceData } from "api/calendar";

import useDrivePicker from "react-google-drive-picker";

import {
    getGoogleApiKey,
} from "api/google";

import {
    getWorkspaceAccessToken,
} from "api/user";

import { third_party_constants } from "constants/third_party_constants";

const EditEventSchema = yup.object().shape({
    eventId: yup.string(),
    title: yup.string(),
    prevWorkspaceId: yup.string(),
    workspaceId: yup.string().required("required"),
    description: yup.string(),
    startDate: yup.date(),
    endDate: yup.date(),
    startTime: yup.date(),
    endTime: yup.date(),
    allDay: yup.boolean().required("required"),
    attendees: yup.array(),
    attachments: yup.array(),
    virtualConferenceType: yup.string(),
    link: yup.string(),
    isUpdate: yup.boolean().required("required"),
});

const initialValuesEditEvent = {
    //eventId: "",
    title: "",
    //workspaceId: "",
    description: "",
    //start: "",
    //end: "",
    //allDay: false,
    attendees: [],
    attachments: [],
    virtualConferenceType: "",
    link: "",
    //isUpdate: false,
};

// create event on submit
const EditEventDialog = ({ open, handleClose, handleSuccess, initialValues }) => {
    const token = useSelector((state) => state.auth.token);
    const allWorkspaces = useSelector((state) => state.auth.user.allWorkspaces);

    const workspaceOptions = Object.entries(allWorkspaces)?.map(([key, value]) => (
        <MenuItem key={key} value={key} disableTouchRipple>
            <Box display="flex" alignItems="center" gap="0.5rem">
                <Avatar src={value.profilePicturePath} sx={{ width: 24, height: 24 }} />
                <ListItemText primary={value.email} />
            </Box>
        </MenuItem>
    ));
    
   /*const defaultValues = {
        ...initialValues,
    }   TODO: ADD DEFAULT VALUE IF MISSING OR IF UNDEFINED
    */
    // setup form context

    const formContext = useForm({
        defaultValues: initialValues,
        resolver: yupResolver(EditEventSchema),
    });
    //const { defaultValues, dirtyFields } = useFormState({ control: formContext.control });
    
    const { control, reset, handleSubmit, formState: { errors, dirtyFields, defaultValues }, getFieldState, setValue, getValues, watch } = formContext;
    
    const attachments = watch("attachments");
    const link = watch("link");
    const virtualConferenceType = watch("virtualConferenceType");
    const attendees = watch("attendees");

    // handle form submission
    const onSubmit = async (values) => {
        console.log(values)
        // close dialog
        reset();
        handleClose();

        // send request to create event
        const response = await createOrUpdateEvent(token, values);
    
        if (response) {
            console.log("successfully created event!");
            console.log(response)
            handleSuccess(response);
        }
        else {
            alert(response.message);
        }
    };

    const onClose = async (id) => {
        // send request to delete event if confernece was created
        if (getValues("eventId") !== defaultValues.eventId) {
            deleteEvent(token, {
                eventId: getValues("eventId"),
                workspaceId: getValues("workspaceId"),
            }).catch((error) => {
                console.log(error);
                alert(error.message);
            });
        }
        // remove conference data if conference was created
        else if (!defaultValues.link && (link || cache.current[getValues("workspaceId")]?.link)) {
            removeConferenceData(token, {
                eventId: getValues("eventId"),
                workspaceId: getValues("workspaceId"),
            }).catch((error) => {
                console.log(error);
                alert(error.message);
            });
        }
        // remove conference data if conference was created

        reset();
        handleClose(id);
    };

    const [openStartDatePicker, setOpenStartDatePicker] = useState(false);
    const [openEndDatePicker, setOpenEndDatePicker] = useState(false);

    const FormDatePicker = ({ name, placeholder, minDate, maxDate, open, onOpen, onClose }) => (
        <Controller
            control={control}
            name={name}
            render={({ field }) => (
                <DatePicker
                    {...field}
                    open={open}
                    onOpen={onOpen}
                    onClose={onClose}
                    minDate={minDate}
                    maxDate={maxDate}
                    format="EEEE, MMMM d"
                    slotProps={{
                        textField: {
                            //disabled: true,
                            //InputLabelProps: { shrink: false },
                            placeholder,
                            size: "small",
                            variant: "standard",
                            onClick: onOpen,
                            sx:{ width: "210px" }
                        },
                        // hide the date picker icon and button
                        openPickerIcon: { style: { display: "none" } },
                        openPickerButton: { style: { display: "none" } },
                    }}
                />
            )}
        />
    );
    
    const FormTimePicker = ({ name, placeholder, open, onOpen, onClose }) => (
        <Controller
            control={control}
            name={name}
            render={({ field }) => (
                <TimePicker
                    {...field}
                    open={open}
                    onOpen={onOpen}
                    onClose={onClose}
                    slotProps={{
                        textField: {
                            //InputLabelProps: { shrink: false },
                            placeholder,
                            size: "small",
                            variant: "standard",
                            sx:{ width: "70px" }
                        },
                    }}
                />
        )}
        />
    );

    const handleVirtualConferenceTypeChange = async (e) => {
        setValue("virtualConferenceType", e.target.value);

        // restore cached values if virtual conference type is the same
        const cachedValues = cache.current[getValues("workspaceId")];
        if (cachedValues?.virtualConferenceType === e.target.value) {
            restoreValuesFromCache(getValues("workspaceId"));
        } else {
         // fetch link from zoom/google/teams, forced to create an event first
            const event = await createOrUpdateEvent(token, getValues());
            console.log(event)

            // update initial values
            setValue("link", event.link);

            if (!getValues("isUpdate")) {
                setValue("eventId", event.id);
                setValue("isUpdate", true);
                setValue("prevWorkspaceId", getValues("workspaceId"));
            }
        }
    };

    const [openPicker, authResponse] = useDrivePicker();  

    // const customViewsArray = [new google.picker.DocsView()]; // custom view
    const handleOpenPicker = async () => {
        const workspaceId = getValues("workspaceId");
        const GOOGLE_ACCESS_TOKEN = await getWorkspaceAccessToken(token, workspaceId);
		const GOOGLE_API_KEY = await getGoogleApiKey(token);

        const customViewsArray = [
            new window.google.picker.DocsView(window.google.picker.ViewId.DOCS)
                .setIncludeFolders(true).setSelectFolderEnabled(true),
        ]; // custom view

        //console.log(customViewsArray)
        //const customViewsArray = ["DOCS", "FOLDERS"]; // custom view
        openPicker({
            clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
            developerKey: GOOGLE_API_KEY,
            token: GOOGLE_ACCESS_TOKEN,
            showUploadView: true,
            showUploadFolders: true,
            supportDrives: true,
            multiselect: true,
            setIncludeFolders: true,        // bugged
            setSelectFolderEnabled: true,   // bugged
            //viewId: "DOCS",
            //viewMimeTypes:    //https://developers.google.com/drive/api/guides/mime-types
            disableDefaultView: true,
            customViews: customViewsArray, // custom view
            callbackFunction: (data) => {
                if (data.action === 'cancel') {
                    console.log('User clicked cancel/close button')
                }
                else if (data.action === 'picked') {
                    console.log('User selected files')

                    // filter out attachments that are already in the list
                    // then normalize the data for google drive attachments
                    const newAttachments = data.docs?.filter((doc) => (
                        attachments.findIndex((attachment) => attachment.fileId === doc.id) === -1
                    ))?.map((doc) => ({
                        fileId: doc.id,
                        fileUrl: doc.url,
                        iconLink: doc.iconUrl,
                        mimeType: doc.mimeType,
                        title: doc.name,
                    }));

                    // append new attachments to the list
                    setValue("attachments", [...attachments, ...newAttachments]);
                }
            },
        });
    }

    // remove attachment from list and update form values
    const handleRemoveAttachment = (index) => {
        // remove the attachment at the given index (1 count)
        attachments.splice(index, 1);
        setValue("attachments", attachments);
    };

    const cache = useRef({});
    const cacheValues = () => {
        cache.current[getValues("workspaceId")] = {
            attachments,
            virtualConferenceType,
            link,
        }
    }
    const restoreValuesFromCache = (workspaceId) => {
        const restore = cache.current[workspaceId] || {
            attachments: [],
            virtualConferenceType: "",
            link: "",
        };

        setValue("attachments", restore.attachments);
        setValue("virtualConferenceType", restore.virtualConferenceType);
        setValue("link", restore.link);
    }
    return (
        <Dialog
            open={open}
            onClose={onClose}
            hideBackdrop
            //PaperProps={{ sx: { p: "1rem" } }}
            sx={{
                p: "1rem",
            }}
        >
            <Box p="1rem">
                { /* FORM */ }
                <form onSubmit={handleSubmit(onSubmit)} >
                    { /* Form Values */ }
                    <Box display="flex" flexDirection="column" gap="1.5rem">

                        { /* TITLE */ }
                        <Box display="flex" justifyContent="space-between" alignItems="center" mb="1rem">
                            <Controller
                                control={control}
                                name="title"
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        placeholder="Add Title"
                                        variant="standard"
                                        //InputLabelProps={{ shrink: false }}
                                        sx={{
                                            width: "80%",
                                        }}
                                        //sx={{ gridColumn: "span 2" }}
                                    />
                                )}
                            />
                            <IconButton onClick={onClose} size="small">
                                <Close />
                            </IconButton>
                        </Box>

                        { /* Workspace Selection */ }
                        <Box display="flex" gap="1rem" alignItems="center">
                            <Workspaces />
                            {/*<Controller
                                control={control}
                                name="workspaceId"
                                    render={({ field }) => (*/}
                                    <Select
                                        //{...field}
                                        size="small"
                                        variant="standard"
                                        label="Select a Workspace"
                                        value={getValues("workspaceId")}
                                        MenuProps={{
                                            anchorOrigin: {
                                                vertical: "bottom",
                                                horizontal: "left"
                                            },
                                            transformOrigin: {
                                                vertical: "top",
                                                horizontal: "left"
                                            },
                                            //getContentAnchorEl: null
                                        }}
                                        renderValue={(workspaceId) => (
                                            // if only one workspace is selected, show its profile picture and the full name
                                            <Box display="flex" alignItems="center" gap="0.5rem">
                                                <Avatar 
                                                    src={allWorkspaces[workspaceId].profilePicturePath} 
                                                    sx={{ width: 24, height: 24 }} 
                                                />
                                                <Typography 
                                                    variant="secondary"
                                                    whiteSpace="nowrap"
                                                    overflow="hidden"
                                                    textOverflow="ellipsis"
                                                >
                                                    {allWorkspaces[workspaceId].email}
                                                </Typography>
                                            </Box>
                                        )}
                                        sx={{ width: "70%" }}
                                        onChange={(event) => {
                                            // cache the old workspace id values that may need to be restored
                                            cacheValues();

                                            // restore old values when workspace changes, if they exist, otherwise set to default
                                            const newWorkspaceId = event.target.value;
                                            restoreValuesFromCache(newWorkspaceId);
                                            
                                            setValue("workspaceId", newWorkspaceId);
                                        }}
                                    >
                                        {workspaceOptions}
                                    </Select>
                                {/*})}
                            />*/}
                        </Box>

                        { /* DATETIME */ }
                        <Box display="flex" gap="1rem" alignItems="center">
                            <AccessTime />
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                            {initialValues.allDay ? (
                                // two date pickers
                                    <Box display="flex" gap="0.5rem">
                                        <FormDatePicker
                                            name="startDate"
                                            placeholder="Start Date"
                                            open={openStartDatePicker}
                                            onOpen={() => { 
                                                setOpenEndDatePicker(false); 
                                                setOpenStartDatePicker(true);
                                            }}
                                            onClose={() => setOpenStartDatePicker(false)}
                                        />

                                        <Typography>&mdash;</Typography>

                                        <FormDatePicker
                                            name="endDate"
                                            placeholder="End Date"
                                            open={openEndDatePicker}
                                            onOpen={() => {
                                                setOpenStartDatePicker(false);
                                                setOpenEndDatePicker(true);
                                            }}
                                            onClose={() => setOpenEndDatePicker(false)}
                                        />
                                    </Box>
                            ) : (
                                // one date picker and two time pickers
                                <Box display="flex" gap="0.5rem">
                                    <FormDatePicker
                                        name="startDate"
                                        placeholder="date"
                                        open={openStartDatePicker}
                                        onOpen={() => {
                                            setOpenEndDatePicker(false);
                                            setOpenStartDatePicker(true);
                                        }}
                                        onClose={() => setOpenStartDatePicker(false)}
                                    />
                                    <FormTimePicker
                                        name="startTime"
                                        placeholder= "Start Time"
                                    />
                                    <Typography>&mdash;</Typography>
                                    <FormTimePicker
                                        name="endTime"
                                        placeholder= "End Time"
                                    />
                                </Box>
                            )}
                            </LocalizationProvider>
                        </Box>

                        { /* add/remove/change virtual conferencing */ }
                        <Box display="flex" gap="1rem" alignItems="center" >
                            {   (virtualConferenceType && link )
                                    ? third_party_constants[virtualConferenceType].icon() 
                                    : <Videocam />
                            }

                            {   // if no virtual conferencing is selected, show dropdown to select one
                                !virtualConferenceType ? (
                                <FormControl 
                                    variant="outlined"
                                    size="small"
                                    sx={{ width:"55%" }}
                                >
                                    <InputLabel>Add Virtual Conferencing</InputLabel>
                                    <Select
                                        value={virtualConferenceType}
                                        onChange={handleVirtualConferenceTypeChange}
                                        label="Add Virtual Conferencing"
                                    >                                    
                                        <MenuItem value={"google_meet"}>Google Meet</MenuItem>
                                        <MenuItem value={"microsoft_teams"}>Microsoft Teams</MenuItem>
                                        <MenuItem value={"zoom"}>Zoom</MenuItem>
                                    </Select>
                                </FormControl>
                            ) : // selected virtual conferencing, link still loading
                                // 40px is same height as button so that dialog doesnt resize
                                !link ? (
                                <Box display="flex" gap="1rem" height="40px" alignItems="center">
                                    <CircularProgress size={24} />
                                    <Typography variant="h6">Creating Virtual Conference</Typography>
                                </Box>
                            ) : (
                                // show button to join virtual conference
                                <Box display="flex" justifyContent="space-between" width="100%">
                                    <Button
                                        variant="contained"
                                        sx={{ textTransform: 'none' }}
                                        href={link} 
                                        target="_blank"
                                        color={third_party_constants[virtualConferenceType].color}
                                    >
                                        <Typography variant="secondary">{`Join on ${third_party_constants[virtualConferenceType].name}`}</Typography>
                                    </Button>

                                    <Box display="flex" alignItems="center">
                                        <Tooltip title="Copy conference link">
                                            <IconButton onClick={() => 
                                                // copy link to clipboard
                                                navigator.clipboard.writeText(link)
                                            }>
                                                <ContentCopy fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title="Remove conference">
                                            <IconButton onClick={() => {
                                                // a newly create event, remove the conference data immediately
                                                if (getValues("eventId") !== defaultValues.eventId) {
                                                    removeConferenceData(token, {
                                                        eventId: getValues("eventId"),
                                                        workspaceId: getValues("workspaceId"),
                                                    }).catch((error) => {
                                                        console.log(error);
                                                    });
                                                } else {
                                                    cacheValues();
                                                }
                                                
                                                // clear values
                                                setValue("virtualConferenceType", "")
                                                setValue("link", "");
                                            }}>
                                                <Close fontSize="small" />
                                            </IconButton>
                                        </Tooltip>
                                    </Box>
                                </Box>
                            )}
                        </Box>

                        { /* add attendees */ }
                        <Box display="flex" gap="1rem" alignItems="center">
                            <People/>
                            <SearchPeopleAutocomplete
                                placeholder="Add Attendees"
                                sx={{ width: "70%" }}
                                value={attendees}
                                multiple
                                handleValueChange={(event, value, reason) => {
                                    const updateAttendees = value?.map((person) => ({
                                        resource: Boolean(person.resource),
                                        id: person.resource,
                                        email: person.email,
                                        displayName: person.displayName,
                                    }));
                                    setValue("attendees", updateAttendees);
                                }}
                            />
                        </Box>

                        
                        { /* add/remove/change description */ }
                        <Box display="flex" gap="1rem" alignItems="flex-start">
                            <Notes/>
                            <Controller
                                control={control}
                                name="description"
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        placeholder="Add a Description"
                                        variant="filled"
                                        InputLabelProps={{ shrink: false }}
                                        fullWidth
                                        multiline
                                        rows={3}
                                    />
                                )}
                            />
                        </Box>

                        { /* Add Attachments */ }
                        <Box display="flex" gap="1rem" alignItems={attachments.length > 0 ? "flex-start" : "center"} >
                            <AttachFile />

                            <Box display="flex" flexDirection="column" gap="0.5rem" alignItems="flex-start">
                                {   attachments.length > 0 &&
                                    <List 
                                        dense 
                                        disablePadding
                                        sx={{
                                            overflow: 'auto',
                                            maxHeight: 165,
                                        }}
                                    >
                                        {attachments?.map((attachment, index) => (
                                            <ListItem 
                                                key={attachment.fileId}
                                                disablePadding
                                                secondaryAction={
                                                    <IconButton edge="end" onClick={() => handleRemoveAttachment(index)}>
                                                        <Close fontSize="small"/>
                                                    </IconButton>
                                                }
                                            >
                                                <ListItemButton
                                                    href={attachment.fileUrl}
                                                    target="_blank"
                                                >
                                                    <ListItemText primary={attachment.title} />
                                                </ListItemButton>
                                            </ListItem>
                                        ))}
                                    </List>
                                }

                                <Button 
                                    variant="text"
                                    sx={{ textTransform: 'none' }}
                                    onClick={handleOpenPicker}
                                >
                                    <Typography variant="secondary">Add Attachment</Typography>
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                    

                    { /* Button Actions */ }
                    <Box display="flex" justifyContent="flex-end" gap="0.5rem" mt="3rem">
                        <Button
                            variant="text"
                            sx={{ textTransform: 'none' }}
                            onClick={() => onClose("cancel")}
                        >
                            <Typography variant="secondary">Cancel</Typography>
                        </Button>
                        <Button
                            variant="contained"
                            sx={{ textTransform: 'none' }}
                            //onClick={() => onClose("save")}
                            type="submit"
                        >
                            <Typography variant="secondary">Save</Typography>
                        </Button>
                    </Box>
                </form>
            </Box>
        </Dialog>
    );
};

export default EditEventDialog;